import { Component, OnInit } from '@angular/core';
import { EnvironmentService, EnvironmentViewModel } from './environments.service';
import { Title } from '@angular/platform-browser';
import { MatSidenavContainer, MatSidenav } from '@angular/material/sidenav';
import { MatNavList, MatListItem } from '@angular/material/list';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';


@Component({
    selector: 'my-package',
    templateUrl: './environments.component.html',
    providers: [Title],
    imports: [MatSidenavContainer, MatSidenav, MatNavList, MatListItem, RouterLink, RouterLinkActive, RouterOutlet]
})
export class EnvironmentsComponent implements OnInit {

    environments: EnvironmentViewModel[];
    constructor(
        private service: EnvironmentService,
        private title: Title
    ) {
        this.title.setTitle("ACT - Environments");
    }

    ngOnInit(): void {
        this.getEnvironments();
    }

    getEnvironments() {
        this.service
            .getEnvironments()
            .subscribe(envs => this.environments = envs);
    }
}